import React from 'react';
import {
    MDBInput, toast, ToastContainer, MDBBtnFixedItem, MDBCard, MDBCardTitle, MDBCardText, MDBFormInline, MDBBadge,
    MDBContainer, MDBListGroup, MDBListGroupItem, MDBRow, MDBCol, MDBBtn, MDBIcon, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter
} from 'mdbreact';
import DataLayer from '../Utilities/DataLayer';
import Header from './ComponentFragments/Header';
import Colors from '../Styles/Colors';
import Formatter from '../Utilities/Formatter';
import SelectSearch from 'react-select-search';

export default class ExperienceCenter extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            productList: [],
            filteredData: [],
            displayData: [],
            orderNo: '',
            hasOrder: false,
            experienceCenters: [],
            selectedExperienceCenter: '',
            modal: false,
            modalItems: []
        }
        this.searchList = this.searchList.bind(this);
        this.formatter = new Formatter();
        this.handleChange = this.handleChange.bind(this);
        this.removeItem = this.removeItem.bind(this);
        this.finalize = this.finalize.bind(this);
        this.setSelectedZone = this.setSelectedZone.bind(this);
        this.props.loaderOff();
    }

    toggle = () => {
        this.setState({
            modal: !this.state.modal
        });
    }

    addToEc = (item) => {
        let arr = this.state.displayData;
        arr.push(item);
        this.setState({
            displayData: arr,
            modal: !this.state.modal
        });
        toast.success(<span style={{ paddingLeft: "15px", fontSize: "18px" }}><MDBIcon icon="check-circle" />&nbsp;&nbsp; "Item Added." </span>, {
            closeButton: false
        });
        //let item = this.state.productList.filter((item) => (item.processingCode.toUpperCase() == phrase.toUpperCase()))
    }

    async setSelectedZone(zone) {
        this.props.loaderOn();
        this.setState({
            productList: []
        })
        var dl = new DataLayer();
        let ECDataResponse = await dl.Get("/shop/getproducts/" + zone);
        this.setState({
            selectedExperienceCenter: zone,
            productList: ECDataResponse.data
        });
        this.props.loaderOff();
    }

    searchList(phrase) {
        let arr = this.state.displayData;
        let item = this.state.productList.filter((item) => (item.processingCode.toUpperCase().includes(phrase.toUpperCase())))
        //this.state.shopData.filter((item) => (item.recognition.toString().includes(phrase)) || item.processingCode.toUpperCase().includes(phrase.toUpperCase()) || (item.invoiceDescription.toUpperCase().includes(phrase.toUpperCase())))
        if (item.length == 1) {
            item[0].qty = 1;
            arr.push(item[0]);
            this.setState({ displayData: arr });
            toast.success(<span style={{ paddingLeft: "15px", fontSize: "18px" }}><MDBIcon icon="check-circle" />&nbsp;&nbsp; "Item Added." </span>, {
                closeButton: false
            });
        } else if (item.length > 1) {
            this.setState({
                modal: true,
                modalItems: item
            });
        }

    }

    async componentWillMount() {
        this.props.loaderOn();
        var dl = new DataLayer();
        
        let ItemResponse = await dl.Get("/experiencecenter/recallitems");
        let ExCentersResponse = await dl.Get("/experiencecenter/getcenters")

        let ecData = [];
        ExCentersResponse.data.forEach((center) => ecData.push({ value: center.shipZoneId, name: center.zoneName }));

        let ECDataResponse = await dl.Get("/shop/getproducts/" + ecData[0].value);

        this.setState({
            productList: ECDataResponse.data,
            displayData: ItemResponse.data,
            orderNo: ItemResponse.otherInfo,
            hasOrder: ItemResponse.otherInfo == "-1" ? false : true,
            experienceCenters: ecData,
            selectedExperienceCenter: ecData[0].value
        });

        this.props.loaderOff();


    }

     async finalize() {
        //this.props.loaderOn();
         const { history } = this.props;
         if (!this.state.hasOrder) {
             var dl = new DataLayer();
             let requestObject = {
                 ecItemList: this.state.displayData
             }
             let response = await dl.Post("/experiencecenter/finalize", requestObject);
         }
         
         history.push({
             pathname: '/salesforce/cart',
             state: { isExperienceCart: true, hasOrder: this.state.hasOrder, orderNo: this.state.orderNo }
         })

        //this.setState({
        //    displayData: []
        //})
        //this.props.updateCartCount(response.data);
        //toast.success(<span style={{ paddingLeft: "15px", fontSize: "18px" }}><MDBIcon icon="check-circle" />&nbsp;&nbsp; Cart generated successfully. </span>, {
        //    closeButton: false
        //});
        //this.props.loaderOff();
    }

    removeItem(item) {
        let displayData = this.state.displayData
        let newDisplay = [];
        displayData.forEach((dispItem) => {
            if (item.processingCode != dispItem.processingCode) {
                newDisplay.push(dispItem);
            }
        });
        this.setState({
            displayData: newDisplay
        })
    }

    handleChange(event, item) {
        let qty = event.target.valueAsNumber

        if (qty < 0) {
            qty = 1;
        }

        let displayData = this.state.displayData
        let index = -1;
        if (item.stockId != 0) {
            index = displayData.findIndex((i) =>
                i.stockId == item.stockId
            );

        } else {
            index = displayData.findIndex((i) =>
                i.shipStockId == item.shipStockId
            );
        }
        displayData[index].qty = qty

        //let changedItems = displayData.cartItems.some((i) => i.qty != i.originalQty);

        this.setState({
            displayData
        })
    }

    render() {
        let headerText = "Experience Center - Select Below";
        return (
            <div>
                <Header headerText={headerText}
                    placeholderText="Search Item"
                    subHeaderText="(Use the processing code and the search field to search for experience center products.)"
                    searchList={this.searchList}
                    searchOnEnter={true}
                    hideSearch={this.state.hasOrder ? true : false}
                />
                <MDBRow className="mt-3">
                    <MDBCol sm="12">
                        <SelectSearch
                            options={this.state.experienceCenters}
                            placeholder="Experience Center..."
                            value={this.state.selectedExperienceCenter}
                            search={false}
                            onChange={(selectedItem) => this.setSelectedZone(selectedItem.value)}
                        />
                    </MDBCol>
                </MDBRow>
                <MDBRow>
                    <MDBCol>
                        {this.state.displayData.length > 0 ?
                            <MDBCard className="card-body" style={{ marginTop: "1rem" }}>
                                <MDBCol sm="12" className="text-right">
                                    <MDBBtn rounded color="purple" size="sm" onClick={this.finalize}><MDBIcon icon="shopping-cart" />&nbsp;{this.state.hasOrder ? 'Go To Checkout' : 'Finalize'}</MDBBtn>
                                </MDBCol>
                                <hr className="hr_grey" />
                                {
                                    this.state.displayData.map((item, index) => {
                                        item.qty == 0 ? item.qty = 1 : item.qty = item.qty
                                        return (
                                            <div key={index}>
                                                <MDBRow className="mx-2" between>
                                                    {/*<MDBCol>
                                                    <img src="https://mdbootstrap.com/img/Others/documentation/1.jpg" className="img-fluid" alt="" />
                                                </MDBCol>*/}
                                                    <MDBCol sm="12">
                                                        <span style={{ color: Colors.purple, fontWeight: "bold" }}>{item.invoiceDescription}</span>
                                                        <br />
                                                    </MDBCol>
                                                    <MDBCol md="6" sm="12">
                                                        <MDBRow>
                                                            <MDBCol>
                                                                <span style={{ fontSize: "14px" }}>Code: {item.processingCode}</span><br />
                                                                <span style={{ fontSize: "14px" }}>Recognition: {this.formatter.formatCurrency(item.recognition)}</span>
                                                            </MDBCol>
                                                            <MDBCol className="text-right">
                                                                <span style={{ fontSize: "14px" }}>Price: {this.formatter.formatCurrency(item.d)}</span><br />
                                                                <span style={{ fontSize: "14px", fontWeight: "bold" }}>Total: {this.formatter.formatCurrency(item.d * item.qty)}</span>
                                                            </MDBCol>
                                                        </MDBRow>
                                                        <span className="cartRemoveItem" onClick={() => this.removeItem(item)}><MDBIcon far icon="trash-alt" /> Remove Item</span>
                                                    </MDBCol>
                                                    <MDBCol md="3" sm="12">
                                                        <MDBInput disabled={this.state.hasOrder} className="mb-0" type="number" label="Qty" value={item.qty} min={1} onChange={(event) => this.handleChange(event, item)} />
                                                    </MDBCol>
                                                </MDBRow>
                                                <hr className="hr_grey" />
                                            </div>


                                        );
                                    })
                                }
                            </MDBCard>
                            : <div></div>
                        }
                    </MDBCol>
                    
                </MDBRow>

                <MDBModal isOpen={this.state.modal} >
                    <MDBModalHeader>Stock Items</MDBModalHeader>
                    <MDBModalBody>
                        {
                            this.state.modalItems.map((item, index) => {
                                return (
                                    <div key={index}>
                                        <MDBRow className="mx-2" between>
                                            {/*<MDBCol>
                                                    <img src="https://mdbootstrap.com/img/Others/documentation/1.jpg" className="img-fluid" alt="" />
                                                </MDBCol>*/}
                                            <MDBCol sm="12">
                                                <span style={{ color: Colors.purple, fontWeight: "bold" }}>{item.invoiceDescription}</span>
                                                <br />
                                            </MDBCol>
                                            <MDBCol sm="12">
                                                <MDBRow>
                                                    <MDBCol>
                                                        <span style={{ fontSize: "14px" }}>Code: {item.processingCode}</span><br />
                                                        
                                                    </MDBCol>
                                                    <MDBCol className="text-right">
                                                        <span style={{ fontSize: "14px" }}>Recognition: {this.formatter.formatCurrency(item.recognition)}</span>
                                                       
                                                    </MDBCol>
                                                </MDBRow>
                                                <MDBRow>
                                                    <MDBCol className="text-right">
                                                        <MDBBtn type="submit" tag="a" color="cyan" floating onClick={() => this.addToEc(item)}>
                                                            <MDBIcon icon="cart-plus" />
                                                        </MDBBtn>
                                                        </MDBCol>
                                                    </MDBRow>
                                            </MDBCol>
                                            
                                        </MDBRow>
                                        <hr className="hr_grey" />
                                    </div>

                                )
                            })
                        }
                    </MDBModalBody>
                    <MDBModalFooter>
                        <MDBBtn color="secondary" onClick={() => this.toggle()}>Close</MDBBtn>
                    </MDBModalFooter>
                </MDBModal>

                <ToastContainer
                    hideProgressBar={true}
                    newestOnTop={true}
                    autoClose={2500}
                />
            </div>
        );
    }
}